// hooks/useHygraph.js
import { useState } from "react";

const API_URL = process.env.REACT_APP_HYGRAPH_API_URL;
const API_TOKEN = process.env.REACT_APP_HYGRAPH_API_TOKEN;

export const useHygraph = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFromHygraph = async (query) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_TOKEN}`,
        },
        body: JSON.stringify({ query }),
      });

      const result = await response.json();

      if (result.errors) {
        throw new Error(result.errors[0].message);
      }

      setLoading(false);
      return result.data;
    } catch (err) {
      setError(err.message);
      setLoading(false);
      return null;
    }
  };

  return { fetchFromHygraph, loading, error };
};
